<ul #grid class="grid {{ cssClasses() }}" [class.grid--initialized]="isInitialized()">
  <ng-content></ng-content>
</ul>
